import '../plugins/googlemap.js'
import style from '../json/mapstyle.json'

export default (obj,markers=[]) => {

  // GoogleMap API の読み込み
  const env_keys = ((keymap,host) =>{
    return (!keymap[host])? keymap['local']: keymap[host]
  })({
    'local': 'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'www.nagainet.co.jp': 'AIzaSyB5ElluPsQvMaOSBT0s95KdFc0aOPeyqWk', //production
    'nagainet.dev.goopy.mp': 'AIzaSyB5ElluPsQvMaOSBT0s95KdFc0aOPeyqWk' //test
  },location.host);
  ((d, s, p, k, c) => {
    const tag = d.createElement(s),f=d.getElementsByTagName('script')[0]
    tag.src=`${p}?key=${k}&callback=${c}`;tag.async = true;
    f.parentNode.insertBefore(tag, null)
  })(document,'script', 'https://maps.googleapis.com/maps/api/js', env_keys, 'load.mapscript.resolve')

  window.load.mapscript.done(() => $(obj).googlemap({
    styleObj: { name: 'mapstyle', style },
    markers
  }))
  
}